import React from "react";
import _ from "underscore";
import classNames from "classnames";
import { Icon } from "armstrong-react";
import { isBrowser, isServer } from "../detection";

import "./inlineTabControl.scss";

interface IInlineTabControlProps extends React.HTMLProps<InlineTabControl> {
  currentTabIndex?: number;
  changeTab: (index: number) => void;
  ignoreScreenSize?: boolean;
}

interface IInlineTabControlState{
  mobileExpanded?: boolean;
  isPhone?: boolean;
}

export class InlineTabControl extends React.Component<IInlineTabControlProps, IInlineTabControlState>{
  constructor(props: IInlineTabControlProps) {
    super(props);
    this.state = { mobileExpanded: true, isPhone: false };
  }
  private checkSize() {
    if (this.props.ignoreScreenSize) {
      return;
    }

    var isPhoneNow = window.innerWidth <= 480;
    if(this.state.isPhone && !isPhoneNow){
      // Display all images
      this.setState({ isPhone: false, mobileExpanded: true });
    }
    if (!this.state.isPhone && isPhoneNow){
      // Display just one imageCount
      this.setState({ isPhone: true, mobileExpanded: false });
    }
  }

  componentWillMount(){
    if (isServer()) {
      return;
    }
    window.addEventListener("resize", this.checkSize.bind(this));
    this.checkSize();
  }
  componentWillUnmount() {
    if (isServer()) {
      return;
    }
    window.removeEventListener("resize", this.checkSize.bind(this))
  }

  changeTab(index: number, disabled?: boolean) {
    if (!disabled) {
      this.props.changeTab(index);
    }
    if (this.state.isPhone){
      this.setState({ mobileExpanded: false });
    }
  }
  render() {
    var tabs = [];
    _.each(this.props.children as any[], (child, index) => {
      var classes = classNames(
        "inline-tab", 
        "fixed", {
          "selected": this.props.currentTabIndex === index, 
          "disabled": child.props ? child.props.disabled : false 
        });

      if (!child.props || !child.props.hidden) {
        tabs.push((
          <InlineTabItem key={`tab_${index}`} style={{ order: index }} className={classes} onClick={() => this.changeTab(index, this.props.disabled) }>
            {child}
          </InlineTabItem>
        ));
      }
    })

    var classes = classNames("inline-tab-control", { "phone": this.state.isPhone, [this.props.className]: this.props.className != null });
    return (
      <div className={classes} style={this.props.style}>

      {this.state.isPhone && <div className="selected-tab-item" onClick={()=> this.setState({mobileExpanded: !this.state.mobileExpanded})}>{this.props.children[this.props.currentTabIndex]}
      <Icon className="tab-control-menu" icon={Icon.Icomoon.arrowDown3}/>
      </div>
    }
      {this.state.mobileExpanded && tabs}
      </div>
    );
  }
}

interface IInlineTabItemProps extends React.HTMLProps<HTMLDivElement> {
  className: string;
  onClick: () => void;
}

export class InlineTabItem extends React.Component<IInlineTabItemProps> {
  render() {
    return <div {...this.props} />
  }
}
